import * as ActionTypes from 'actions/Blacklist';
import * as AuthActionTypes from 'actions/Auth';
import { get } from 'lodash';

const initialState = {
  blacklistEntries: [],
  blacklistEntry: null,
  blacklistEntriesPage: 0,
  powerboxTableFilter: {
    search: '',
  },
  licenseTableFilter: {
    search: '',
  },
  powerboxTableSorting: {},
  licenseTableSorting: {},
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AuthActionTypes.LOGOUT.SUCCESS:
      return { ...initialState };
    case ActionTypes.SET_LICENSE_BLACKLIST_TABLE_FILTER:
      return { ...state, licenseTableFilter: action.payload };
    case ActionTypes.SET_LICENSE_BLACKLIST_TABLE_SORTING:
      return { ...state, licenseTableSorting: action.payload };
    case ActionTypes.SET_POWERBOX_BLACKLIST_TABLE_FILTER:
      return { ...state, powerboxTableFilter: action.payload };
    case ActionTypes.SET_POWERBOX_BLACKLIST_TABLE_SORTING:
      return { ...state, powerboxTableSorting: action.payload };
    case ActionTypes.GET_BLACKLIST_ENTRIES.SUCCESS:
      return {
        ...state,
        blacklistEntries: get(action.payload, 'content', []),
        blacklistEntriesPage: get(action, 'payload.currentPage', 0),
        blacklistEntriesPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_BLACKLIST_POWERBOX.SUCCESS:
      return {
        ...state,
        blacklistPowerbox: get(action.payload, 'content', []),
        blacklistPowerboxPage: get(action, 'payload.currentPage', 0),
        blacklistPowerboxPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_BLACKLIST_LICENSE.SUCCESS:
      return {
        ...state,
        blacklistLicense: get(action.payload, 'content', []),
        blacklistLicensePage: get(action, 'payload.currentPage', 0),
        blacklistLicensePages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_BLACKLIST_ENTRY.SUCCESS:
      return {
        ...state,
        blacklistEntry: action.payload,
      };
    default:
      return state;
  }
}
